<template>
  <div>
    <div class="card-body-2">
        <div style="flex: 1;"></div>
        <div class="card-body-2-data">
          <span class="card-body-2-data-text card-header-text">Long: &nbsp; &nbsp; &nbsp;</span>
          <span class="card-body-2-data-text"> {{ pos_emitter.x }}</span>
        </div>
        <div class="card-body-2-data">
          <span class="card-body-2-data-text card-header-text">Lat: &nbsp; &nbsp; &nbsp;</span>
          <span class="card-body-2-data-text"> {{ pos_emitter.y }}</span>
        </div>
        <div class="card-body-2-buttons-container">
          <span class="button-standard" v-on:click="accept">Accept</span>       
          <span class="button-standard" v-on:click="cancel">Cancel</span> 
        </div>      
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from "vuex";

export default {
  name: 'input6MapSource',
  computed: {
    ...mapGetters({
      status: 'ui/status', 
      current_interface: 'ui/current_interface',
      pos_emitter: 'urn/pos_emitter'
    })
  },
  data() {
    return {
      temp_long: null,
      temp_lat: null,
    }
  },
  created () {

  },
  mounted () {
    this.temp_long = this.pos_emitter.x
    this.temp_lat = this.pos_emitter.y
  },
  methods: {
    accept: function () {
      this.temp_long = null
      this.temp_lat = null
      this.$store.dispatch('ui/change_current_interface', 1)
    },
    cancel: function () {
      this.$store.dispatch('urn/change_pos_emitter_x', this.temp_long)
      this.$store.dispatch('urn/change_pos_emitter_y', this.temp_lat)
      this.$store.dispatch('ui/change_current_interface', 1)
    }
  }
}
</script>